import { Configuration } from '@azure/msal-browser'

export const msalConfig: Configuration = {
   auth: {
      clientId: process.env.REACT_APP_CLIENT_ID,
      authority: 'https://login.microsoftonline.com/burdysolutions.onmicrosoft.com',
      redirectUri: process.env.REACT_APP_BASE_URL,
   },
   cache: {
      cacheLocation: 'sessionStorage',
   },
}
